import {SET_PAYMENTLOG } from '../../actions';

export const paymentlog = (state = [], action) => {
  switch (action.type) {
	case SET_PAYMENTLOG:
      return [...action.value];  
    default: return state;
  }
}